import router from '@/router'

export default function handlePage(value: string) {
  router.push(`/${value}`);
}